module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/stores/4_269debef53ecd291c64e99db2245c8da.jpg";